"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uuid = require("uuid");
var _carbonComponentsReact = require("carbon-components-react");
var _Checkbox = _interopRequireDefault(require("../../../Checkbox/Checkbox"));
var _CurrencyFormatter = _interopRequireDefault(require("../../../../common/Formatters/CurrencyFormatter"));
var _FormFieldsColumn = require("../../../Form/FormFieldsColumn");
var _NumberInput = _interopRequireDefault(require("../../../NumberInput/NumberInput"));
var _TextInput = _interopRequireDefault(require("../../../TextInput/TextInput"));
var _TextArea = _interopRequireDefault(require("../../../TextArea/TextArea"));
var _Dropdown = _interopRequireDefault(require("../../../Dropdown/Dropdown"));
var _EntryFormAccordionItem = _interopRequireDefault(require("./EntryFormAccordionItem"));
var _calculateTotal = _interopRequireDefault(require("../calculateTotal"));
var _Total = _interopRequireDefault(require("../../Total/Total"));
var _EntryFormController = require("./EntryFormController");
var _Label = _interopRequireDefault(require("../../../Dropdown/Label"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const info = ['specXFunc', 'employmentLevel', 'employmentStatus'];
const time = ['yearlyNominalTime', 'vacation'];
const payroll = ['baseSalary', 'addBenefits', 'varBenefits'];
const absence = ['personalHolidays', 'illnessAccidentDoctor', 'militaryCivilService', 'maternityPaternityLeave', 'publicOffices', 'vocationalSchool'];
const nonOrderRelatedAttendance = ['educationTraining', 'advertisingAcquisition', 'contest', 'managementLeadership', 'edvOperation', 'others'];
const ColumnGenerator = (formData, formErrors, translate, onChange, onDropdownChange, dropdownOptions, allSpecXFunc, allOpen) => {
  const isSectionFinished = section => {
    let arr = [];
    let result = true;
    if (section === 'personal-info') {
      arr = ['nameOrNum', 'employmentGrade', 'specXFunc', 'employmentLevel', 'employmentStatus', 'sex', 'yearOfBirth', 'yearlyNominalTime', 'vacation', 'baseSalary', 'addBenefits', 'varBenefits'];
      arr.forEach(param => {
        if (formData[param] === null) {
          return result = false;
        }
      });
      return result;
    }
    if (section === 'absence') {
      arr = ['personalHolidays', 'illnessAccidentDoctor', 'militaryCivilService', 'maternityPaternityLeave', 'publicOffices', 'vocationalSchool'];
      arr.forEach(param => {
        if (formData[param] === null) {
          result = false;
        }
      });
      return result;
    }
    if (section === 'presence') {
      arr = ['educationTraining', 'advertisingAcquisition', 'contest', 'managementLeadership', 'edvOperation', 'others'];
      arr.forEach(param => {
        if (formData[param] === null) {
          result = false;
        }
      });
      return result;
    }
    if (section === 'remarks') {
      return result;
    }
  };
  const generateEmployeeFunctionBlock = item => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "specXFuncBlock"
    }, translate(`benchmarking.survey.employee.entry-form.${item}`)), /*#__PURE__*/_react.default.createElement(_Label.default, null, translate(`benchmarking.survey.employee.entry-form.${item}.tooltip`)), /*#__PURE__*/_react.default.createElement("div", {
      className: "specXFunc"
    }, /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
      key: item,
      id: (0, _EntryFormController.generateId)(item),
      label: ' ',
      placeholder: translate(`benchmarking.dropdown.placeholder`),
      items: formData.showAllSpecXFunc ? allSpecXFunc : dropdownOptions[item],
      onChange: (event, option, error) => onDropdownChange(item, option, error),
      value: formData[item],
      invalidPatternText: formErrors[item],
      invalidText: formErrors[item],
      narrow: true,
      hideLabel: true
    }), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      id: "specXFunc_checkbox",
      label: translate('benchmarking.survey.employee.entry-form.specXFunc.all.label'),
      value: formData.showAllSpecXFunc || false,
      onChange: (event, value) => onChange('showAllSpecXFunc', value, null)
    })));
  };
  return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Accordion, {
    className: "entry-form-accordion"
  }, /*#__PURE__*/_react.default.createElement(_EntryFormAccordionItem.default, {
    className: "entry-form-item",
    isOpen: allOpen,
    title: translate('benchmarking.survey.employee.entry-form.personal-info.section.title'),
    allRowsFilled: isSectionFinished('personal-info')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "content-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_FormFieldsColumn.FormFieldsColumn, null, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    id: (0, _EntryFormController.generateId)('nameOrNum'),
    placeholder: translate('benchmarking.survey.employee.entry-form.nameOrNum.placeholder'),
    label: translate('benchmarking.survey.employee.entry-form.nameOrNum'),
    tooltip: translate('benchmarking.survey.employee.entry-form.nameOrNum.tooltip'),
    value: formData.nameOrNum,
    onChange: (event, value, error) => onChange('nameOrNum', value, error),
    invalidPatternText: formErrors.nameOrNum,
    invalidText: formErrors.nameOrNum,
    autoFocus: true
  }), /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
    id: (0, _EntryFormController.generateId)('employmentGrade'),
    placeholder: '%',
    label: translate(`benchmarking.survey.employee.entry-form.employmentGrade`),
    tooltip: translate('benchmarking.survey.employee.entry-form.employmentGrade.tooltip'),
    value: formData.employmentGrade,
    onChange: (event, value, error) => onChange('employmentGrade', value, error),
    invalidPatternText: formErrors.employmentGrade,
    invalidText: formErrors.employmentGrade,
    formatting: '%'
  }), info.map(item => {
    return item === 'specXFunc' ? generateEmployeeFunctionBlock(item) : /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
      key: item,
      id: (0, _EntryFormController.generateId)(item),
      label: translate(`benchmarking.survey.employee.entry-form.${item}`),
      tooltip: translate(`benchmarking.survey.employee.entry-form.${item}.tooltip`),
      placeholder: translate(`benchmarking.dropdown.placeholder`),
      items: dropdownOptions[item],
      onChange: (event, option, error) => onDropdownChange(item, option, error),
      value: formData[item],
      invalidPatternText: formErrors[item],
      invalidText: formErrors[item]
    });
  }), /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
    id: (0, _EntryFormController.generateId)('sex'),
    label: translate(`benchmarking.survey.employee.entry-form.sex`),
    tooltip: translate(`benchmarking.survey.employee.entry-form.sex.tooltip`),
    placeholder: translate(`benchmarking.dropdown.placeholder`),
    items: dropdownOptions['sex'],
    onChange: (event, option, error) => onDropdownChange('sex', option, error),
    value: formData['sex'],
    invalidPatternText: formErrors['sex'],
    invalidText: formErrors['sex']
  }), /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
    id: (0, _EntryFormController.generateId)('yearOfBirth'),
    label: translate(`benchmarking.survey.employee.entry-form.yearOfBirth`),
    tooltip: translate(`benchmarking.survey.employee.entry-form.yearOfBirth.tooltip`),
    value: formData.yearOfBirth || '',
    onChange: (event, value, error) => onChange('yearOfBirth', value, error),
    placeholder: "yyyy",
    invalidPatternText: "Invalid field format: e.g. yyyy",
    invalidText: formErrors.yearOfBirth
  })), /*#__PURE__*/_react.default.createElement(_FormFieldsColumn.FormFieldsColumn, null, time.map(item => /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
    key: item,
    id: (0, _EntryFormController.generateId)(item),
    placeholder: "00.00 h",
    label: translate(`benchmarking.survey.employee.entry-form.${item}`),
    tooltip: translate(`benchmarking.survey.employee.entry-form.${item}.tooltip`),
    value: formData[item],
    onChange: (event, value, error) => onChange(item, value, error),
    invalidPatternText: formErrors[item],
    invalidText: formErrors[item],
    formatting: "h"
  })), /*#__PURE__*/_react.default.createElement(_Total.default, {
    className: "sia-padding-04-bottom",
    title: `${translate('benchmarking.survey.employee.entry-form.targetTime')}${formData.employmentGrade ? ' ' + formData.employmentGrade + ' %' : ''}`,
    value: _CurrencyFormatter.default.formatAlternate((0, _calculateTotal.default)(formData, 'time'), 'h'),
    tooltip: translate('benchmarking.survey.employee.entry-form.targetTime.tooltip')
  }), payroll.map(item => /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
    key: item,
    id: (0, _EntryFormController.generateId)(item),
    placeholder: _CurrencyFormatter.default.formatAlternate(100, 'CHF'),
    label: translate(`benchmarking.survey.employee.entry-form.${item}`),
    tooltip: translate(`benchmarking.survey.employee.entry-form.${item}.tooltip`),
    value: formData[item],
    onChange: (event, value, error) => onChange(item, value, error),
    invalidPatternText: formErrors[item],
    invalidText: formErrors[item],
    formatting: "CHF"
  })), /*#__PURE__*/_react.default.createElement(_Total.default, {
    title: `${translate('benchmarking.survey.employee.entry-form.grossSalary')}${formData.employmentGrade ? ' ' + formData.employmentGrade + ' %' : ''}`,
    value: _CurrencyFormatter.default.formatAlternate((0, _calculateTotal.default)(formData, 'payroll'), 'CHF'),
    tooltip: translate('benchmarking.survey.employee.entry-form.grossSalary.tooltip')
  })))), /*#__PURE__*/_react.default.createElement(_EntryFormAccordionItem.default, {
    isOpen: allOpen,
    title: translate('benchmarking.survey.employee.entry-form.absence.section.title'),
    allRowsFilled: isSectionFinished('absence')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "content-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_FormFieldsColumn.FormFieldsColumn, null, absence.slice(0, 3).map(item => /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
    key: item,
    id: (0, _EntryFormController.generateId)(item),
    placeholder: "00.00 h",
    label: translate(`benchmarking.survey.employee.entry-form.${item}`),
    tooltip: translate(`benchmarking.survey.employee.entry-form.${item}.tooltip`),
    value: formData[item],
    onChange: (event, value, error) => onChange(item, value, error),
    invalidPatternText: formErrors[item],
    invalidText: formErrors[item],
    formatting: "h"
  }))), /*#__PURE__*/_react.default.createElement(_FormFieldsColumn.FormFieldsColumn, null, absence.slice(3, 6).map(item => /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
    key: item,
    id: (0, _EntryFormController.generateId)(item),
    placeholder: "00.00 h",
    label: translate(`benchmarking.survey.employee.entry-form.${item}`),
    tooltip: translate(`benchmarking.survey.employee.entry-form.${item}.tooltip`),
    value: formData[item],
    onChange: (event, value, error) => onChange(item, value, error),
    invalidPatternText: formErrors[item],
    invalidText: formErrors[item],
    formatting: "h"
  })))), /*#__PURE__*/_react.default.createElement(_Total.default, {
    className: "sia-padding-04-bottom",
    title: `${translate('benchmarking.survey.employee.entry-form.absence.total')}${formData.employmentGrade ? ' ' + formData.employmentGrade + ' %' : ''}`,
    value: _CurrencyFormatter.default.formatAlternate((0, _calculateTotal.default)(formData, 'absence'), 'h')
  })), /*#__PURE__*/_react.default.createElement(_EntryFormAccordionItem.default, {
    isOpen: allOpen,
    title: translate('benchmarking.survey.employee.entry-form.presence.section.title'),
    allRowsFilled: isSectionFinished('presence')
  }, /*#__PURE__*/_react.default.createElement(_Total.default, {
    className: "sia-padding-02-top sia-padding-02-bottom",
    title: `${translate('benchmarking.survey.employee.entry-form.targetTime')}${formData.employmentGrade ? ' ' + formData.employmentGrade + ' %' : ''}`,
    value: _CurrencyFormatter.default.formatAlternate((0, _calculateTotal.default)(formData, 'time'), 'h'),
    tooltip: translate('benchmarking.survey.employee.entry-form.targetTime.tooltip')
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "content-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_FormFieldsColumn.FormFieldsColumn, null, /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
    id: (0, _EntryFormController.generateId)('overUnderTime'),
    placeholder: "00.00 h",
    label: translate(`benchmarking.survey.employee.entry-form.overUnderTime`),
    tooltip: translate(`benchmarking.survey.employee.entry-form.overUnderTime.tooltip`),
    value: formData.overUnderTime,
    onChange: (event, value, error) => onChange('overUnderTime', value, error),
    invalidPatternText: formErrors['overUnderTime'],
    invalidText: formErrors['overUnderTime'],
    formatting: "h",
    allowNegatives: true
  }))), /*#__PURE__*/_react.default.createElement(_Total.default, {
    className: "sia-padding-04-bottom",
    title: `${translate('benchmarking.survey.employee.entry-form.yearlyPresenceTime')}${formData.employmentGrade ? ' ' + formData.employmentGrade + ' %' : ''}`,
    tooltip: translate(`benchmarking.survey.employee.entry-form.yearlyPresenceTime.tooltip`),
    value: _CurrencyFormatter.default.formatAlternate((0, _calculateTotal.default)(formData, 'yearlyPresenceTime'), 'h')
  }), /*#__PURE__*/_react.default.createElement("h4", {
    className: "form-total sia-text-04 sia-padding-03-bottom"
  }, translate('benchmarking.survey.employee.entry-form.nonOrderRelatedAttendance')), /*#__PURE__*/_react.default.createElement("div", {
    className: "content-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_FormFieldsColumn.FormFieldsColumn, null, nonOrderRelatedAttendance.slice(0, 3).map(item => /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
    key: item,
    id: (0, _EntryFormController.generateId)(item),
    placeholder: "00.00 h",
    label: translate(`benchmarking.survey.employee.entry-form.${item}`),
    tooltip: translate(`benchmarking.survey.employee.entry-form.${item}.tooltip`),
    value: formData[item],
    onChange: (event, value, error) => onChange(item, value, error),
    invalidPatternText: formErrors[item],
    invalidText: formErrors[item],
    formatting: "h"
  }))), /*#__PURE__*/_react.default.createElement(_FormFieldsColumn.FormFieldsColumn, null, nonOrderRelatedAttendance.slice(3, 6).map(item => /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
    key: item,
    id: (0, _EntryFormController.generateId)(item),
    placeholder: "00.00 h",
    label: translate(`benchmarking.survey.employee.entry-form.${item}`),
    tooltip: translate(`benchmarking.survey.employee.entry-form.${item}.tooltip`),
    value: formData[item],
    onChange: (event, value, error) => onChange(item, value, error),
    invalidPatternText: formErrors[item],
    invalidText: formErrors[item],
    formatting: "h"
  })))), /*#__PURE__*/_react.default.createElement(_Total.default, {
    title: `${translate('benchmarking.survey.employee.entry-form.not-order-related.total')} ${formData.employmentGrade ? ' ' + formData.employmentGrade + ' %' : ''}`,
    value: _CurrencyFormatter.default.formatAlternate((0, _calculateTotal.default)(formData, 'nonOrderRelatedAttendance'), 'h')
  }), /*#__PURE__*/_react.default.createElement(_Total.default, {
    className: "sia-padding-02-top sia-padding-05-bottom",
    title: `${translate('benchmarking.survey.employee.entry-form.order-related.total')}${formData.employmentGrade ? ' ' + formData.employmentGrade + ' %' : ''}`,
    value: _CurrencyFormatter.default.formatAlternate((0, _calculateTotal.default)(formData, 'orderRelatedAttendance'), 'h')
  })), /*#__PURE__*/_react.default.createElement(_EntryFormAccordionItem.default, {
    isOpen: allOpen,
    title: translate('benchmarking.survey.employee.entry-form.remarks.section.title'),
    allRowsFilled: isSectionFinished('remarks')
  }, /*#__PURE__*/_react.default.createElement(_TextArea.default, {
    id: (0, _uuid.v4)(),
    label: translate('benchmarking.survey.employee.entry-form.remarks'),
    value: formData.remarks || ' ',
    onChange: (event, value, error) => onChange('remarks', value, error)
  })));
};
ColumnGenerator.propTypes = {
  formData: _propTypes.default.object,
  formErrors: _propTypes.default.object,
  translate: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onDropdownChange: _propTypes.default.func,
  dropdownOptions: _propTypes.default.object,
  allSpecXFunc: _propTypes.default.array
};
var _default = exports.default = ColumnGenerator;